<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="administrator"
      :validate-on-rule-change="false"
      label-position="right"
      label-width="130px"
      class="form"
    >
      <el-form-item label="所属管理员">
        <v-avatar-nickname :value="administrator.avatar" :nickname="administrator.nickname"/>
      </el-form-item>
      <el-form-item label="新密码" prop="user_password">
        <el-input
          v-model="administrator.user_password"
          placeholder="请输入登录密码"
          minlength="8"
          maxlength="16"
          show-word-limit
          clearable
        />
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          :loading="isSaving"
          @click="handleSubmit"
        >
          保存修改
        </el-button>
        <el-button @click="RouteConfig.administratorList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, updatePasswordByAdministrator } from '@/api/administrator';

export default {
  name: RouteConfig.administratorEditPasswordByAdministrator.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    administrator: {
      avatar: '',
      nickname: '',
      user_password: '',
    },
    rules: {
      user_password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const { user_password } = this.administrator;
        this.isSaving = true;
        const { isError } = await updatePasswordByAdministrator(this.id, { user_password });
        this.isSaving = false;
        if (isError) return;

        // 若重置的是自己的密码，后端已使旧 token 失效，需要主动退出重新登录
        if (this.id === this.$store.getters.userId) {
          await this.$store.dispatch('user/logout', { is_not_auto_login: 1 });
          this.$message.success('密码已修改，请使用新密码重新登录');
          return;
        }
        RouteConfig.administratorList.back();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { administrator } = this;
      Object.keys(data).forEach(key => {
        if (key in administrator) administrator[key] = data[key];
      });
    },
  },
};
</script>
